<template>
  <div>
    <v-container fluid class="py-10 px-12">
      <v-item-group>
        <v-container>
          <v-row><a href="/category">Category List</a></v-row>
          <v-row><a href="/networked-ini">Networked INI</a></v-row>
          <v-row><a href="/migration">Migration</a></v-row>
          <v-row>
            <v-col
              v-for="item in items"
              :key="item.name"
              cols="12"
              fill-height
              md="6"
              lg="4"
            >
              <v-item v-slot:default="{ active }">
                <v-card
                  :data-cy="`${item.name}-openBtn`"
                  :color="active ? 'primary' : ''"
                  @click="navigate(item.route)"
                  class="elevation-0 och-card--tile"
                  height="100%"
                >
                  <v-card-text class="px-12">
                    <div class="text-center">
                      <v-icon large color="primary">{{ item.icon }}</v-icon>
                    </div>
                    <div class="display-1 text-center mt-3 primary--text">
                      {{ item.name }}
                    </div>
                    <v-divider class="my-2"></v-divider>
                    <div class="grey--text text--darken-3">
                      {{ item.description }}
                    </div>
                  </v-card-text>
                </v-card>
              </v-item>
            </v-col>
          </v-row>
        </v-container>
      </v-item-group>
    </v-container>
  </div>
</template>
<script>
export default {
  data() {
    return {
      items: [
        {
          description:
            "Shows a list of all organizations in Valet. Allows for creation, deletion and updating of organizations.",
          icon: "fas fa-hospital-alt",
          name: "Organizations",
          route: "ochinOrganizationList",
        },
        {
          description:
            "Allows for the creation of primary roles, question/answer templates that all align with Epic security templates.",
          icon: "fas fa-user-shield",
          name: "User Security",
          route: "ochinUserSecurity",
        },
        {
          description:
            "Import location extracts from the NMQ.",
          icon: "fas fa-map-marker-alt",
          name: "Locations",
          route: "ochinLocation",
        },
      ],
    };
  },
  methods: {
    navigate(name) {
      this.$router.push({ name });
    },
  },
  name: "ochinMenu",
};
</script>

<style>
.och-card--tile {
  border: 2px solid var(--v-accent-darken2) !important;
  border-radius: 20px !important;
}
</style>
